module.exports = __webpack_public_path__ + "img/imgXharra-9.73d90760.png";